import { machine, connect, collection as comboboxCollection } from '@zag-js/combobox';
import { useMachine } from '@zag-js/svelte';
import { useConnect } from '../../utils/useConnect.svelte.js';
/**
 * Initializes and returns a reactive combobox state machine connected to the combobox API.
 * @param items The array of items to use in the combobox.
 * @param props Additional properties for the combobox machine.
 */
export const useCombobox = (items, props) => {
    // let options = $state.raw(items);
    const collection = comboboxCollection({
        items,
        itemToValue: (item) => item.value,
        itemToString: (item) => item.label
    });
    // console.log(collection)
    const service = useMachine(machine, {
        ...props,
        collection,
        onOpenChange({ open }) {
            if (open && props.clearOnOpen) {
                // Clear the input value when opening to show all options
                service.send({ type: 'INPUT_VALUE.SET', value: '' });
                collection.setItems(items);
            }
        },
        onInputValueChange({ inputValue }) {
            const filtered = items.filter((item) => item.label.toLowerCase().includes(inputValue.toLowerCase()));
            const newOptions = filtered.length > 0 ? filtered : items;
            collection.setItems(newOptions);
            // options = newOptions
        },
        closeOnSelect: true,
        inputBehavior: 'autohighlight'
    });
    const reactiveConnectApi = useConnect(service, connect);
    return reactiveConnectApi;
};
